import React, { memo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import SimpleBar from 'simplebar-react';
import RecordItem from './RecordItem';

type RecordProps = {
  items: any[];
  loading?: boolean;
};

const Record: React.FC<RecordProps> = (props) => {
  
  const handleClickRow = () => {

  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        '& *': { color: 'primary.dark', fontSize: '12px' },
        '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
          backgroundColor: '#CCD1D9',
        },
        overflow: 'hidden',
        width: '666px',
      }}
    >
      <SimpleBar
        style={{ height: 'calc(100vh - 250px)', borderWidth: '18px' }}
      >
        <Table
          stickyHeader
          sx={{
            width: '100%',
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '1px solid #F3F3F3',
              fontWeight: 700,
              fontSize: '12px',
              height: '36px',
              p: '0px 16px',
            }
          }}
          aria-label='simple table'>
          <TableHead >
            <TableRow >
              <TableCell align={'left'} sx={{ minWidth: '95px' }}>日付</TableCell>
              <TableCell align={'left'} sx={{ minWidth: '140px' }}>患者名</TableCell>
              <TableCell align={'left'} sx={{ minWidth: '80px' }}>入出庫</TableCell>
              <TableCell align={'left'} sx={{ minWidth: '60px' }}>数量</TableCell>
              <TableCell align={'left'} sx={{ minWidth: '88px' }}>仕入価格</TableCell>
              <TableCell align={'left'} sx={{ minWidth: '88px' }}>購入価格</TableCell>
              <TableCell align={'left'} sx={{ minWidth: '114px' }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.loading ? (
              <TableRow>
                <TableCell colSpan={props.items.length}>
                  <Stack spacing={1}>
                    <Skeleton variant='rounded' width={'100%'} height={40} />
                    <Skeleton variant='rounded' width={'100%'} height={40} />
                    <Skeleton variant='rounded' width={'100%'} height={40} />
                  </Stack>
                </TableCell>
              </TableRow>
            ) : (
              <>
                <RecordItem
                  items={props.items}
                  handleClickRow={handleClickRow}
                />
                {props.items.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      sx={{ textAlign: 'center', verticalAlign: 'center' }}
                    >
                      データがありません
                    </TableCell>
                  </TableRow>
                )}
              </>
            )}
          </TableBody>
        </Table>
      </SimpleBar>
    </TableContainer>
  );
};

export default memo(Record);
